import React from 'react';
import { Chip, TableCell, TableRow } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { ROUTES } from 'module/navigation/enums/routes.enums';
import { formatDateWith12HourTime } from 'shared/utils/dateUtils';
import { Shift } from 'core/API/shifts';
import { ShiftPeriod } from '../utils/scheduleWidget';
import EmployeeWidgetCard from './EmployeeWidgetCard';

interface ScheduleShift extends Shift {
	period: ShiftPeriod;
}

interface EmployeeScheduleWidgetProps {
	loading: boolean;
	shifts: ScheduleShift[];
}

const PERIOD_CONFIG: Record<
	ShiftPeriod,
	{ label: string; color: 'primary' | 'warning' | 'default'; borderColor: string }
> = {
	today: { label: 'Today', color: 'primary', borderColor: '#1976d2' },
	'this-week': { label: 'This Week', color: 'warning', borderColor: '#ed6c02' },
	later: { label: 'Later', color: 'default', borderColor: '#9e9e9e' },
};

const formatShiftTime = (iso: string): string => formatDateWith12HourTime(iso);

const EmployeeScheduleWidget = ({ loading, shifts }: EmployeeScheduleWidgetProps) => (
	<EmployeeWidgetCard
		title="My Schedule"
		loading={loading}
		colSpan={4}
		emptyMessage="No upcoming shifts"
		isEmpty={shifts.length === 0}
		header={
			<TableRow>
				<TableCell>When</TableCell>
				<TableCell>Role</TableCell>
				<TableCell>Start</TableCell>
				<TableCell>End</TableCell>
			</TableRow>
		}
	>
		{shifts.map((shift) => {
			const periodConfig = PERIOD_CONFIG[shift.period];
			return (
				<TableRow
					key={shift.id}
					sx={{ borderLeft: `4px solid ${periodConfig.borderColor}` }}
				>
					<TableCell>
						<Chip
							size="small"
							className="employee-widget-period-chip"
							label={periodConfig.label}
							color={periodConfig.color}
							variant="filled"
						/>
					</TableCell>
					<TableCell>
						<NavLink to={ROUTES.HYPERSCHEDULER} className="employee-widget-link">
							{shift.jobCode?.label || 'Shift'}
						</NavLink>
					</TableCell>
					<TableCell>{formatShiftTime(shift.startAt)}</TableCell>
					<TableCell>{formatShiftTime(shift.endAt)}</TableCell>
				</TableRow>
			);
		})}
	</EmployeeWidgetCard>
);

export default EmployeeScheduleWidget;
